import { render } from "./QuizQuestionEditor.vue?vue&type=template&id=7aa0d252&scoped=true"
import script from "./QuizQuestionEditor.vue?vue&type=script&lang=js"
export * from "./QuizQuestionEditor.vue?vue&type=script&lang=js"

import "./QuizQuestionEditor.vue?vue&type=style&index=0&id=7aa0d252&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa0d252"]])

export default __exports__